var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Scheduler" } }),
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass: "page-container",
          class: { "py-3": !_vm.isMobile, mobile: _vm.isMobile },
          attrs: { "grid-list-xl": "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  class: { "pb-0": _vm.isMobile },
                  attrs: { xs12: "", sm6: "" }
                },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "add-by-button",
                          class: { active: _vm.addBy === "PROVIDER" },
                          attrs: { slot: "activator", block: "" },
                          on: {
                            click: function($event) {
                              _vm.addBy = "PROVIDER"
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n            Add by provider\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Select provider and add to student service")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  class: { "pt-0": _vm.isMobile },
                  attrs: { xs12: "", sm6: "" }
                },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { disabled: !_vm.showTooltip, top: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "add-by-button",
                          class: { active: _vm.addBy === "STUDENT" },
                          attrs: { slot: "activator", block: "" },
                          on: {
                            click: function($event) {
                              _vm.addBy = "STUDENT"
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n            Add by student\n          ")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Select student and add provider(s) to service")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.addBy === "PROVIDER"
            ? _c("provider-add", { attrs: { showTooltip: _vm.showTooltip } })
            : _vm._e(),
          _vm._v(" "),
          _vm.addBy === "STUDENT"
            ? _c("student-add", { attrs: { showTooltip: _vm.showTooltip } })
            : _vm._e(),
          _vm._v(" "),
          _c("bottom-nav"),
          _vm._v(" "),
          _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-430cf971", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430cf971","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/scheduler/scheduler-container.vue
// module id = null
// module chunks = 